var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{attrs:{"data":_vm.dataset,"options":_vm.sampleOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }